import React, { useEffect } from 'react';
import { Field } from 'formik'
import { FormikSelectComponent } from '../../../utilities/formUtils'


const TransType = ({ name, isTxn, isLabel, label, isSelection, setOnSelect, placeholder, userProps, width, getvalue: callback, index, type }, props) => {

    const getSelectedValue = (values) => {
        // console.log("Vtype Selected", values)
    
    }
    const options = [
        { key: 1, text: 'WI_WC', value: 'WI_WC' },
        { key: 2, text: 'R', value: 'R' },
        { key: 3, text: 'VP', value: 'VP' },
        { key: 4, text: 'PP', value: 'PP' },
        { key: 5, text: 'VS_VC', value: 'VS_VC' }
    ]


    return (
        <Field name={name} isLabel={isLabel} isTxn={isTxn} label={label} isSelection={isSelection} component={FormikSelectComponent} userProps={{ options, getValue: getSelectedValue, index, placeholder }} placeholder={placeholder} width={width}> </Field>
    )

}


export default TransType;